import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';
import { EstimativaNegociacao } from '../interface/estimativa-negociacao';

@Injectable({
  providedIn: 'root'
})
export class EstimativaNegociacaoLookupService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrestnegociacao`;

  constructor(private httpClient: HttpClient) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string): Observable<EstimativaNegociacao> {
    return this.httpClient.get<EstimativaNegociacao>(`${this.url}/${value}`);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CZACCDNGC',  optional: true, gridColumns: 3, label: 'Cód Negociação'},
      {property: 'CZACFAZEND', optional: true, gridColumns: 3, label: 'Cód Fazenda'},
      {property: 'CZACDSCFAZ', optional: true, gridColumns: 6, label: 'Descr. Fazenda'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CZACCDNGC'      , label: 'Cód. Negociação'},
      {property: 'CZACDSCFAZ'     , label: 'Fazenda'        },
      {property: 'CZACPROJET'     , label: 'Projetos'       },
      {property: 'CZACINTERVDESC' , label: 'Intervenção'    },
    ];
  }

  getFieldFormater(value: EstimativaNegociacao): string {
    return `${value.CZACCDNGC} - ${value.CZACDSCFAZ}`;
  }
}
